"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const snap_ui_1 = require("@teamsnap/snap-ui");
const validation_1 = require("core/validation");
const React = __importStar(require("react"));
const useAmpli_1 = require("src/hooks/useAmpli");
const layouts_1 = require("../shared/layouts");
const useInvitation_1 = require("./useInvitation");
const InviteRole = () => {
    const { newUser: { firstName, lastName, phone, relationship, isBirthdayPublic }, rosterFirstName, setUser, submitRole, submitUser, userIsRosterMember, setUserIsRosterMember, guardianSelected, setGuardianSelected, errors, isProcessing, } = React.useContext(useInvitation_1.InvitationContext);
    const formVisible = userIsRosterMember || guardianSelected;
    const { screenViewed } = (0, useAmpli_1.useAmpli)();
    React.useEffect(() => {
        screenViewed(useAmpli_1.AmplitudeScreenNames.INVITE_ROLE);
    }, []);
    const onSubmit = () => {
        guardianSelected && submitRole();
        userIsRosterMember && submitUser();
    };
    return (React.createElement(layouts_1.InvitePageWrapper, null,
        React.createElement(layouts_1.InviteHeader, { className: "sui-mb-1", headerText: "You're so close to joining your team!" }),
        React.createElement("p", { className: "sui-body sui-text-center sui-mb-3" }, "Tell us if you're joining yourself or on behalf of your child."),
        React.createElement("div", { className: "sui-block sui-w-full invite-form" },
            React.createElement("p", { className: "sui-label sui-mb-1" },
                "Are you ",
                rosterFirstName,
                "?"),
            React.createElement(snap_ui_1.BorderedRadio, { className: "sui-mb-1 sui-p-2", label: `Yes, I'm ${rosterFirstName}`, value: "player", selected: userIsRosterMember, onSelect: () => {
                    setUserIsRosterMember(true);
                    setGuardianSelected(false);
                } }),
            React.createElement(snap_ui_1.BorderedRadio, { className: "sui-p-2", label: "No, I'm a parent or guardian", value: "guardian", selected: guardianSelected, onSelect: () => {
                    setGuardianSelected(true);
                    setUserIsRosterMember(false);
                } }),
            formVisible && (React.createElement("div", { className: "sui-my-2" },
                guardianSelected && (React.createElement(snap_ui_1.Select, { className: "sui-my-2", label: `Your relationship to ${rosterFirstName}`, required: true, name: "relationship", onChange: (e) => {
                        // @ts-ignore
                        setUser('relationship', e.toString());
                    }, value: relationship, options: ['Mom', 'Dad', 'Guardian'], errors: errors?.relationship ? [errors.relationship] : [] })),
                React.createElement(snap_ui_1.Input, { label: "Your first name", required: true, name: "firstName", className: "sui-my-2", onChange: (e) => {
                        setUser('firstName', e.target.value.replace(validation_1.SPECIAL_CHARACTERS_REGEX, ''));
                    }, placeholder: "", inputProps: { maxLength: 40 }, value: firstName || '', type: "text", errors: errors?.firstName ? [errors.firstName] : [] }),
                React.createElement(snap_ui_1.Input, { label: "Your last name", required: true, name: "lastName", className: "sui-my-2", onChange: (e) => {
                        setUser('lastName', e.target.value.replace(validation_1.SPECIAL_CHARACTERS_REGEX, ''));
                    }, placeholder: "", inputProps: { maxLength: 40 }, value: lastName || '', type: "text", errors: errors?.lastName ? [errors.lastName] : [] }),
                React.createElement(snap_ui_1.PhoneInput, { label: "Your phone number", name: "phone", className: "sui-mt-2", onChange: (e) => {
                        setUser('phone', e.target.value);
                    }, placeholder: "xxx-xxx-xxxx", inputProps: {
                        inputMode: 'tel',
                    }, value: phone || '', defaultCountryCode: "US", errors: errors?.phone ? [errors.phone] : [] }),
                userIsRosterMember && (React.createElement("div", { className: "sui-flex sui-justify-between sui-items-center sui-mt-2" },
                    React.createElement(snap_ui_1.Label, { htmlFor: "isBirthdayPublic", "data-testid": "birthday-public-label" }, "Add date of birth to roster profile"),
                    React.createElement(snap_ui_1.Toggle, { name: "isBirthdayPublic", on: isBirthdayPublic, onClick: (_e) => {
                            setUser('isBirthdayPublic', !isBirthdayPublic);
                        } }))),
                React.createElement(snap_ui_1.LabelButton, { "data-testid": "continue-button", className: "sui-min-w-full sui-mt-2", labelText: "Continue", onClick: onSubmit, loading: isProcessing, size: "default", variantType: "primary" }))))));
};
exports.default = InviteRole;
